<template>
  <v-dialog v-model="openDialog" max-width="500">
    <v-form ref="filterForm" @submit.prevent>
      <v-card>
        <v-card-title class="headline">Filtrar {{ title }}</v-card-title>
        <v-card-text class="pb-0">
          <component :is="filter" @datachange="setSearchFields($event)"></component>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" text @click="openDialog = false">
            Cancelar
          </v-btn>
          <v-btn color="default" text @click="clearFields()">
            Limpar filtro
          </v-btn>
          <v-btn color="primary" text @click="filterFields()">
            Filtrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapMutations } from 'vuex'

import customersFilter from '@/components/Filters/Customers'
import celebrationsFilter from '@/components/Filters/Celebrations'
import invoicesFilter from '@/components/Filters/Invoices'

export default {
  name: 'filterModal',
  components: {
    customersFilter,
    celebrationsFilter,
    invoicesFilter
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    page: {
      required: true,
      type: String
    }
  },
  data: () => ({
    openDialog: false,
    params: {}
  }),
  computed: {
    filter () {
      return this.page + 'Filter'
    }
  },
  watch: {
    open (val) {
      if (this.openDialog !== val) this.openDialog = val
    },
    openDialog (val) {
      if (this.open !== val) this.$emit('close')
    }
  },
  methods: {
    ...mapMutations(['SET_SEARCH_PARAMS']),
    setSearchFields (formData) {
      this.params = {}
      for (let key in formData) {
        if (formData[key].value) this.params[key] = formData[key].value
      }
    },
    filterFields () {
      this.SET_SEARCH_PARAMS({ page: this.page, params: this.params })
      this.openDialog = false
    },
    clearFields (formData) {
      this.params = {}
      this.SET_SEARCH_PARAMS({ page: this.page, params: {}, clear: true })
      this.openDialog = false
    }
  }
}
</script>
